import Request from "../Clients/AxiosReq";
const resource = "/api/v1/auth";

export default {
  login(payload) {
    return Request.post(`${resource}/login`, payload);
  },
  signup(payload) {
    return Request.post(`${resource}/signup`, payload);
  },
  resetPassword(payload) {
    // return Request.post(`${resource}/reset-password`, payload);
  },
  logout() {
    return Request.post(`${resource}/logout`);
  },
  sendOTP(payload) {
    return Request.post(`${resource}/send-otp`, payload);
  },
  verifyOTP(payload) {
    return Request.post(`${resource}/verify-otp`, payload);
  },
  user() {
    return Request.get(`${resource}/user`);
  },
  resetPassword(payload) {
    return Request.post(`${resource}/password/reset-wa`, payload);
  },
};
